import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useCurrentMaster, usePrevious } from '@lib/hooks';
import { includes } from 'lodash';

export default function useDatadogStartSessionReplayRecording() {
  const currentMaster = useCurrentMaster();
  const prevMasterId = usePrevious(currentMaster?.id);
  const isLumaUser = includes(currentMaster?.email, '@lumahealth.io');
  const isDemoAccount = /demo\+[\w]+@lumahealth\.io/.test(currentMaster?.email ?? '');

  React.useEffect(() => {
    // Start datadogSessionReplay only for real Users
    if (currentMaster && !isLumaUser && !isDemoAccount && currentMaster.id !== prevMasterId) {
      datadogRum.startSessionReplayRecording();
    }
  }, [currentMaster, isDemoAccount, isLumaUser, prevMasterId]);

  return null;
}
